// QR Kiosk v2 — honest "no photograph on file" machine silhouette plate.
// Ported verbatim from designer kiosk-shared.jsx (KioskLathe + SilhouettePlate).
// Strokes/fills already tokenized (var(--faint) + color-mix). The `note` string
// is passed already-translated by the CONSUMER (or null to hide) — no copy here.
import React from "react";

export interface KioskLatheProps {
  w?: number | string;
  h?: number | string;
}

export function KioskLathe({ w = "72%", h = "60%" }: KioskLatheProps) {
  const stroke = "var(--faint)";
  const fill = "color-mix(in oklab, var(--faint) 24%, transparent)";
  return (
    <svg width={w} height={h} viewBox="0 0 140 70" fill="none">
      <rect x="6" y="40" width="128" height="14" rx="2" fill={fill} stroke={stroke} />
      <rect x="12" y="22" width="34" height="18" fill={fill} stroke={stroke} />
      <rect x="92" y="22" width="42" height="18" fill={fill} stroke={stroke} />
      <rect x="42" y="28" width="50" height="6" fill={stroke} opacity="0.7" />
      <circle cx="44" cy="31" r="6" stroke={stroke} fill="none" />
      <rect x="60" y="54" width="6" height="10" fill={stroke} opacity="0.6" />
      <rect x="80" y="54" width="6" height="10" fill={stroke} opacity="0.6" />
    </svg>
  );
}

export interface SilhouettePlateProps {
  w?: number | string;
  h?: number | string;
  /** Already-translated note (e.g. "no photograph on file"), or null to hide. */
  note?: string | null;
  radius?: number;
}

export function SilhouettePlate({ w, h, note = null, radius = 8 }: SilhouettePlateProps) {
  return (
    <div
      style={{
        width: w,
        height: h,
        borderRadius: radius,
        background: "var(--bg-soft)",
        border: "1px solid var(--border-soft)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <KioskLathe />
      {note && (
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 8,
            color: "var(--faint)",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
          }}
        >
          {note}
        </span>
      )}
    </div>
  );
}
